import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/pages/stores/change-request-approved.css';
import SelectSearch from '../../common/SelectSearch';
import ReactCalender from '../../common/Datepicker';
import Card from '../../common/Card';
import Input from '../../common/Input';
import Button from '../../common/Button';
import Modal from '../../common/Modal';
import Label from '../../common/Label';
import Pagination from '../../common/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchCompetitorChains,
    fetchCompetitorChainsByStoreCode,
    fetchCompetitorStores,
    fetchCompetitorStoresByStoreCode,
    fetchDivisions,
    fetchSources,
    fetchStores,
    setLoader,
} from '../../../redux/actions/api';
import { createCompetitorChainOptions, createCompetitorStoreMultiOptions, createStoreOptions } from '../../../utils/helpers/option';
import EditTable from '../../tables/EditTable';
import { getTableChangeRequestApproved, getTableFreshnessChangeRequestApproved } from '../../tables/table';
import { ChangeRequestControllerService } from '../../../services';
import { setToastsError, setToastsSuccess } from '../../../redux/actions/common';
import Choice from '../../common/Choice';
import apiErrorHandler from '../../../api/apiErrorHandler';
import { setDeleteConfirm, setIsDeleteContinue } from '../../../redux/actions/modal';
import { useLocation } from 'react-router-dom';
import { clearErrors } from '../../../redux/actions/error';
import MultiSelect from '../../common/MultiSelect';
import { maxEndDateMinFourteen } from '../../../utils/helpers/date';
import { setChangeRequestType } from '../../../redux/actions/storage';

const ChangeRequestApproved = (props) => {
    const { type } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();

    const sort = useSelector((state) => state.sort);

    const constants = useSelector((state) => state.constants);
    const { divisions, competitorChains, competitorStores, sources, stores } = constants;

    const storage = useSelector((state) => state.storage);
    const { changeRequestType, isFreshness, isCompetitor, isInstruction, isHeadquarter } = storage;

    const modal = useSelector((state) => state.modal);
    const { isDeleteContinue } = modal;

    const [state, setState] = useState({
        departments: [],
        lines: [],
        classes: [],
        subclasses: [],
        selectedDivision: {},
        selectedRequest: [],

        storeCode: '',
        jan: '',
        startDate: '',
        endDate: '',
        selectedDepartment: '',
        selectedLine: null,
        selectedClass: null,
        selectedSubclass: null,
        competitorChainCode: [],
        competitorStoreCode: [],
        competitorChainCodes: [],
        competitorStoreCodes: [],
        selectedData: [],

        selectedSource: '',
        selectedStartDate: '',
        selectedEndDate: '',
        authorizerName: '',

        isShowPleaseSelect: false,
        isShowPleaseDeleteSelect: false,
        isShowModalApprove: false,
        isSearched: false,
        isInstructionSelect: false,
        isDelete: false,

        paginate: new Date(),

        page: 1,
        limit: 30,
        apiResponse: null,
    });

    const {
        departments,
        lines,
        classes,
        subclasses,
        selectedRequest,

        storeCode,
        jan,
        startDate,
        endDate,
        selectedDepartment,
        selectedLine,
        selectedClass,
        selectedSubclass,
        competitorChainCode,
        competitorStoreCode,
        competitorChainCodes,
        competitorStoreCodes,
        selectedData,

        selectedSource,
        selectedStartDate,
        selectedEndDate,
        authorizerName,

        isShowPleaseSelect,
        isShowPleaseDeleteSelect,
        isShowModalApprove,
        isSearched,
        isInstructionSelect,
        isDelete,

        paginate,

        page,
        limit,
        apiResponse,
    } = state;

    const [stateDataDatePicker] = useState({
        minStartDate: new Date(),
        // 2日後の日付を取得
        maxStartDate: new Date(new Date().setDate(new Date().getDate() + 2)),
        minEndDate: new Date(),
    });
    const { minStartDate, maxStartDate, minEndDate } = stateDataDatePicker;

    useEffect(() => {
        handleClear();
        dispatch(clearErrors());
        dispatch(fetchDivisions());
        dispatch(fetchSources());
        dispatch(fetchStores());
        if (isHeadquarter) {
            dispatch(fetchCompetitorChains());
            dispatch(fetchCompetitorStores());
            dispatch(setChangeRequestType(type));
        } else {
            dispatch(fetchCompetitorChainsByStoreCode());
            dispatch(fetchCompetitorStoresByStoreCode());
        }
    }, [dispatch, location]);

    useEffect(() => {
        getChangeRequestsApproved();
    }, [page, sort, changeRequestType]);

    useEffect(() => {
        if (isDeleteContinue) {
            dispatch(clearErrors());
            dispatch(setLoader(true));
            handleSubmitModalDelete();
        }
    }, [isDeleteContinue]);

    // 初期表示時に部門をセット
    useEffect(() => {
        if (divisions) {
            const departments = divisions
                .sort((a, b) => a.departmentCode - b.departmentCode)
                .filter((item) => item.departmentCode > 0 && item.lineCode === 0 && item.classCode === 0 && item.subclassCode === 0)
                .map((item) => {
                    return {
                        ...item,
                        value: item.departmentCode,
                        label: item.divisionName,
                    };
                });
            setState((prevState) => ({
                ...prevState,
                departments,
            }));
        }
    }, [divisions]);

    // 部門が変更された場合にラインをセット
    useEffect(() => {
        const filteredDivisions = divisions?.filter((item) => {
            return item.departmentCode === selectedDepartment && item.lineCode > 0 && item.classCode === 0 && item.subclassCode === 0;
        });

        const lines = filteredDivisions
            .sort((a, b) => a.departmentCode - b.departmentCode || a.lineCode - b.lineCode)
            .map((item) => {
                return {
                    ...item,
                    value: item.lineCode,
                    label: item.divisionName,
                };
            });

        setState((prevState) => ({
            ...prevState,
            filteredDivisions,
            lines,
            selectedLine: null,
            selectedClass: null,
            selectedSubclass: null,
        }));
    }, [divisions, selectedDepartment]);

    // ラインが変更された場合にクラスをセット
    useEffect(() => {
        const filteredDivisions = divisions?.filter((item) => {
            return (
                item.departmentCode === selectedDepartment &&
                item.lineCode === selectedLine &&
                item.classCode > 0 &&
                item.subclassCode === 0
            );
        });

        const classes = filteredDivisions
            .sort((a, b) => a.departmentCode - b.departmentCode || a.lineCode - b.lineCode || a.classCode - b.classCode)
            .map((item) => {
                return {
                    ...item,
                    value: item.classCode,
                    label: item.divisionName,
                };
            });

        setState((prevState) => ({
            ...prevState,
            filteredDivisions,
            classes,
            selectedClass: null,
            selectedSubclass: null,
        }));
    }, [divisions, lines, selectedDepartment, selectedLine]);

    // クラスが変更された場合にサブクラスをセット
    useEffect(() => {
        const filteredDivisions = divisions?.filter((item) => {
            return (
                item.departmentCode === selectedDepartment &&
                item.lineCode === selectedLine &&
                item.classCode === selectedClass &&
                item.subclassCode > 0
            );
        });

        const subclasses = filteredDivisions
            .sort(
                (a, b) =>
                    a.departmentCode - b.departmentCode ||
                    a.lineCode - b.lineCode ||
                    a.classCode - b.classCode ||
                    a.subclassCode - b.subclassCode,
            )
            .map((item) => {
                return {
                    ...item,
                    value: item.subclassCode,
                    label: item.divisionName,
                };
            });

        setState((prevState) => ({
            ...prevState,
            filteredDivisions,
            subclasses,
            selectedSubclass: null,
        }));
    }, [classes, divisions, selectedClass, selectedDepartment, selectedLine]);

    const table = isFreshness ? getTableFreshnessChangeRequestApproved(t) : getTableChangeRequestApproved(t);

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleChangeMultiState = (field, option = []) => {
        setState((prevState) => ({
            ...prevState,
            [field]: option,
        }));
    };

    const handleChainChange = (option, values) => {
        const newCompetitorStoreCode = competitorStoreCode?.filter((store) => values.some((value) => store.value.startsWith(value)));

        const newCompetitorStoreCodes = competitorStoreCodes?.filter((store) => values.some((value) => store.startsWith(value)));

        handleChangeMultiState('competitorStoreCode', newCompetitorStoreCode);
        handleChangeMultiState('competitorStoreCodes', newCompetitorStoreCodes);
    };

    const filteredChildOptions = competitorChainCode ? createCompetitorStoreMultiOptions(competitorStores, competitorChainCodes) : [];

    const handleCloseModal = () => {
        setState((prevState) => ({
            ...prevState,
            isShowPleaseSelect: false,
            isShowPleaseDeleteSelect: false,
            isInstructionSelect: false,
        }));
    };

    const getSelectedData = () => {
        return apiResponse?.data.filter((item) => item.selected) || [];
    };

    const handleContinuationRegister = () => {
        if (selectedData.length === 0) {
            setState((prevState) => ({
                ...prevState,
                isShowPleaseSelect: true,
            }));
        } else {
            if (selectedData.some((item) => item.competitorStoreCode === '99999999')) {
                setState((prevState) => ({
                    ...prevState,
                    isInstructionSelect: true,
                }));
            } else {
                setState((prevState) => ({
                    ...prevState,
                    isShowModalApprove: true,
                }));
            }
        }
    };

    const handleDelete = () => {
        if (isFreshness) {
            setState((prevState) => ({
                ...prevState,
                selectedRequest: selectedData,
                isShowPleaseDeleteSelect: true,
            }));
        } else {
            if (selectedData.length === 0) {
                setState((prevState) => ({
                    ...prevState,
                    isShowPleaseDeleteSelect: true,
                }));
            } else {
                dispatch(setDeleteConfirm(true));
            }
        }
    };

    const handlePageClick = (event) => {
        handleChangeState('page', event.selected + 1);
    };

    const handleClear = () => {
        setState((prevState) => ({
            ...prevState,
            jan: '',
            startDate: '',
            endDate: '',
            storeCode: '',
            selectedDepartment: '',
            selectedLine: null,
            selectedClass: null,
            selectedSubclass: null,
            competitorChainCode: [],
            competitorStoreCode: [],
            competitorChainCodes: [],
            competitorStoreCodes: [],
        }));
    };

    const handleSetSelectedData = () => {
        if (apiResponse) {
            const displayData = apiResponse.data;
            setState((prevState) => {
                const newData = [
                    ...prevState.selectedData.filter(
                        (item) =>
                            !displayData.some((newItem) => newItem.tokubaiProjectCode === item.tokubaiProjectCode && !newItem.selected),
                    ),
                    ...displayData.filter(
                        (newItem) =>
                            newItem.selected &&
                            !prevState.selectedData.some((item) => item.tokubaiProjectCode === newItem.tokubaiProjectCode),
                    ),
                ];

                return {
                    ...prevState,
                    selectedData: newData,
                };
            });
        }
    };

    const getChangeRequestsApproved = (pageNumber) => {
        dispatch(setLoader(true));
        dispatch(clearErrors());
        if (pageNumber) {
            handleChangeState('page', pageNumber);
            handleChangeState('selectedData', []);
        } else if (apiResponse) {
            handleSetSelectedData();
        }
        const isChanged = () => {
            const values = [jan, startDate, endDate, selectedDepartment, storeCode];
            const nulls = [selectedLine, selectedClass, selectedSubclass];
            const arrays = [competitorChainCode, competitorStoreCode];
            return (
                values.some((value) => value !== '') || nulls.some((value) => value !== null) || arrays.some((value) => value.length !== 0)
            );
        };

        // 検索条件が入力されているか確認
        if (isChanged()) {
            handleChangeState('isSearched', true);
        } else {
            handleChangeState('isSearched', false);
        }

        // 検索
        ChangeRequestControllerService.getChangeRequestsApproved({
            changeRequestType: changeRequestType,
            departmentCode: selectedDepartment ? selectedDepartment : null,
            lineCode: selectedLine ? selectedLine : null,
            classCode: selectedClass ? selectedClass : null,
            subclassCode: selectedSubclass ? selectedSubclass : null,
            storeCode: storeCode ? storeCode : null,
            jan: jan ? jan : null,
            startDate: startDate ? startDate : null,
            endDate: endDate ? endDate : null,
            competitorChainCodes: competitorChainCodes.length === 0 ? null : competitorChainCodes,
            competitorStoreCodes: competitorStoreCodes.length === 0 ? null : competitorStoreCodes,
            page: page,
            limit: limit,
            sortField: table.heads.find((head) => head.field === sort.sortField)?.field,
            sortType: sort.sortType,
        })
            .then((response) => {
                const responseData = response.data?.map((item) => ({
                    ...item,
                    selected: selectedData.some((dataItem) => dataItem.tokubaiProjectCode === item.tokubaiProjectCode),
                }));

                setState((prevState) => ({
                    ...prevState,
                    apiResponse: { ...response, data: responseData },
                }));
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error);
            })
            .finally(() => {
                handleChangeState('paginate', new Date());
                dispatch(setLoader(false));
            });
    };

    const handleCloseModalApprove = () => {
        setState((prevState) => ({
            ...prevState,
            isShowModalApprove: false,
            selectedSource: '',
            selectedStartDate: '',
            selectedEndDate: '',
            authorizerName: '',
        }));
    };

    const handleSubmitModalApprove = () => {
        if (selectedStartDate > selectedEndDate) {
            dispatch(setToastsError('終了日は開始日以降の日付を選択してください。'));
            return;
        }

        dispatch(setLoader(true));
        dispatch(clearErrors());
        // 継続登録処理
        ChangeRequestControllerService.createChangeRequestContinuation({
            changeRequestType: changeRequestType,
            source: selectedSource,
            salesStartDate: selectedStartDate,
            salesEndDate: selectedEndDate,
            authorizerName: authorizerName,
            items: selectedData.map((item) => {
                return {
                    jan: item.jan,
                    discountedRequestSellingPrice: item.discountedRequestSellingPrice,
                    competitorStoreCode: item.competitorStoreCode,
                };
            }),
        })
            .then(() => {
                dispatch(setToastsSuccess('継続登録が完了しました。'));
                handleCloseModalApprove();
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, t('message.error.registration'));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

    const handleSubmitModalDelete = () => {
        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('isDelete', true);

        const deleteRequest = isHeadquarter
            ? ChangeRequestControllerService.deleteApprovedChangeRequestForHeadquarter({
                  storeCode: selectedData[0].storeCode,
                  tokubaiProjectCodes: selectedData.map((item) => {
                      return item.tokubaiProjectCode;
                  }),
              })
            : ChangeRequestControllerService.deleteApprovedChangeRequest({
                  tokubaiProjectCodes: selectedData.map((item) => {
                      return item.tokubaiProjectCode;
                  }),
              });

        // 削除処理
        deleteRequest
            .then(() => {
                dispatch(setDeleteConfirm(false));
                dispatch(setIsDeleteContinue(false));
                setState((prevState) => ({
                    ...prevState,
                    isShowPleaseDeleteSelect: false,
                    isDelete: false,
                    selectedData: [],
                    apiResponse: null,
                }));
                dispatch(setToastsSuccess('削除が完了しました。'));
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, t('message.error.delete'));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

    useEffect(() => {
        if (!isDelete && apiResponse === null) {
            getChangeRequestsApproved();
        }
    }, [isDelete]);

    const setDataTable = (data) => {
        setState((prevState) => ({
            ...prevState,
            apiResponse: {
                ...state.apiResponse,
                data,
            },
        }));
    };

    return (
        <>
            <div className="okc-inner">
                <Card handleSubmit={() => getChangeRequestsApproved(1)} handleClear={handleClear}>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('update_competitor_master.search_form.ok_store.text')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <SelectSearch
                                    onChange={(option) => handleChangeState('storeCode', option.value)}
                                    options={createStoreOptions(stores)}
                                    value={storeCode}
                                    placeholder={t('price_request.oke_store_name.placeholder')}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <Label
                                type="column"
                                text={t('approved_registration_price.search_form.jan.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <Input
                                    className="form-control form-control--input"
                                    type="text"
                                    value={jan}
                                    maxLength="16"
                                    placeholder={t('approved_registration_price.search_form.jan.placeholder')}
                                    autocomplete="off"
                                    onChange={(value) => {
                                        handleChangeState('jan', value);
                                    }}
                                />
                            </div>
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.division_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4" data-select2-id="select2-data-36-36wo">
                        <SelectSearch
                            options={departments}
                            placeholder={t('prohibited_product_list.search_form.division.placeholder')}
                            onChange={(target) => {
                                handleChangeState('selectedDivision', target);
                                handleChangeState('selectedDepartment', target.value);
                            }}
                            value={selectedDepartment}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('approved_registration_price.search_form.jan.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <Input
                                    className="form-control form-control--input"
                                    type="text"
                                    value={jan}
                                    maxLength="16"
                                    placeholder={t('approved_registration_price.search_form.jan.placeholder')}
                                    autocomplete="off"
                                    onChange={(value) => {
                                        handleChangeState('jan', value);
                                    }}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.start_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={startDate}
                                    onChange={(value) => {
                                        handleChangeState('startDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                />
                            </div>
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.line_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4" data-select2-id="select2-data-65-e7mx">
                        <SelectSearch
                            options={lines}
                            placeholder={t('price_registration.search_form.line_name.placeholder')}
                            onChange={(target) => {
                                handleChangeState('selectedDivision', target);
                                handleChangeState('selectedLine', target.value);
                            }}
                            value={selectedLine}
                            disabled={!selectedDepartment}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.start_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={startDate}
                                    onChange={(value) => {
                                        handleChangeState('startDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.end_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={endDate}
                                    onChange={(value) => {
                                        handleChangeState('endDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                    minDate={new Date(new Date().setDate(new Date().getDate() - 15))}
                                />
                            </div>
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.class_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4" data-select2-id="select2-data-87-0prc">
                        <SelectSearch
                            options={classes}
                            placeholder={t('price_registration.search_form.class_name.placeholder')}
                            onChange={(target) => {
                                handleChangeState('selectedDivision', target);
                                handleChangeState('selectedClass', target.value);
                            }}
                            value={selectedClass}
                            disabled={!selectedLine}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.end_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={endDate}
                                    onChange={(value) => {
                                        handleChangeState('endDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                    minDate={new Date(new Date().setDate(new Date().getDate() - 15))}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            {!isFreshness && (
                                <>
                                    <Label
                                        type="column"
                                        text={t('approved_registration_price.search_form.competitor_chain.title')}
                                        className="col-lg-2 mb-2 mb-lg-4"
                                    />
                                    <div className="col-lg-4 pr-lg-3 mb-4" data-select2-id="select2-data-14-3y7t">
                                        <MultiSelect
                                            placeholder={t('export_summary.competitive_chain.placeholder')}
                                            onChange={(option, codes) => {
                                                handleChangeMultiState('competitorChainCode', option);
                                                handleChangeMultiState('competitorChainCodes', codes);
                                                handleChainChange(option, codes);
                                            }}
                                            options={createCompetitorChainOptions(competitorChains)}
                                            value={competitorChainCode}
                                        />
                                    </div>
                                </>
                            )}
                            {isFreshness && <div className="col-lg-6"></div>}
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.subclass_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4" data-select2-id="select2-data-91-1ji8">
                        <SelectSearch
                            options={subclasses}
                            placeholder={t('price_registration.search_form.subclass_name.placeholder')}
                            onChange={(target) => {
                                handleChangeState('selectedDivision', target);
                                handleChangeState('selectedSubclass', target.value);
                            }}
                            value={selectedSubclass}
                            disabled={!selectedClass}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            {!isFreshness && (
                                <>
                                    <Label
                                        type="column"
                                        text={t('approved_registration_price.search_form.competitor_chain.title')}
                                        className="col-lg-2 mb-2 mb-lg-4"
                                    />
                                    <div className="col-lg-4 pr-lg-3 mb-4" data-select2-id="select2-data-14-3y7t">
                                        <MultiSelect
                                            placeholder={t('export_summary.competitive_chain.placeholder')}
                                            onChange={(option, codes) => {
                                                handleChangeMultiState('competitorChainCode', option);
                                                handleChangeMultiState('competitorChainCodes', codes);
                                                handleChainChange(option, codes);
                                            }}
                                            options={createCompetitorChainOptions(competitorChains)}
                                            value={competitorChainCode}
                                        />
                                    </div>
                                </>
                            )}
                            {isFreshness && <div className="col-lg-6"></div>}
                        </>
                    ) : (
                        <div className="col-lg-6"></div>
                    )}
                    {!isFreshness && (
                        <>
                            <Label
                                type="column"
                                text={t('approved_registration_price.search_form.competitor_store.title')}
                                className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                                style={{ height: '40px' }}
                            />
                            <div className="col-lg-4 mb-4">
                                <MultiSelect
                                    placeholder={t('export_summary.competitive_store.placeholder')}
                                    onChange={(option, codes) => {
                                        handleChangeMultiState('competitorStoreCode', option);
                                        handleChangeMultiState('competitorStoreCodes', codes);
                                    }}
                                    options={filteredChildOptions}
                                    value={competitorStoreCode}
                                    disabled={!competitorChainCode.length}
                                />
                            </div>
                        </>
                    )}
                </Card>
                <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                <div className="tab-pane show active">
                    <EditTable
                        isHeightTr
                        confirmStatus="CONFIRMED"
                        isSearched={!isSearched}
                        heads={table.heads}
                        body={table.body}
                        dataTable={apiResponse?.data}
                        setDataTable={setDataTable}
                        pagination={paginate}
                        setSelectedData={handleSetSelectedData}
                    />
                    <div className="okc-delete d-flex justify-content-end mb-5">
                        {isCompetitor && !isHeadquarter && (
                            <Button className="btn btn--primary upload-registration__submit" onClick={handleContinuationRegister}>
                                <span className="btn-text">継続登録</span>
                            </Button>
                        )}
                        {!isInstruction && (
                            <Button className="btn btn--primary upload-registration__submit ml-3" onClick={handleDelete}>
                                <span className="btn-text">削除</span>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
            {!isFreshness && (
                <Modal
                    size="sm"
                    type="please_select_checkbox"
                    isShow={isShowPleaseSelect}
                    onClose={handleCloseModal}
                    isShowIconClose="true"
                    title={t('approved_registration_price.modal.continue_registration.title')}
                    btnList={[
                        {
                            name: t('button.OK'),
                            className: 'btn--primary',
                            onClick: () => handleCloseModal(),
                            disabled: false,
                        },
                    ]}
                >
                    <p className="text-center">{t('approved_registration_price.modal.continue_registration.body.text_03')}</p>
                </Modal>
            )}
            {!isFreshness && (
                <Modal
                    size="sm"
                    type="please_select_checkbox"
                    isShow={isShowPleaseDeleteSelect}
                    onClose={handleCloseModal}
                    isShowIconClose="true"
                    title="選択した商品のデータを削除します。"
                    btnList={[
                        {
                            name: t('button.OK'),
                            className: 'btn--primary',
                            onClick: () => handleCloseModal(),
                            disabled: false,
                        },
                    ]}
                >
                    <p className="text-center">削除するデータを選択してください。</p>
                </Modal>
            )}
            {isFreshness && (
                <Modal
                    size="sm"
                    type="please_select_checkbox"
                    isShow={isShowPleaseDeleteSelect}
                    onClose={handleCloseModal}
                    isShowIconClose="true"
                    title="選択した商品のデータを削除します。"
                    btnList={[
                        ...(selectedRequest.length > 0
                            ? [
                                  {
                                      name: t('button.OK'),
                                      className: 'btn--primary',
                                      onClick: () => handleSubmitModalDelete(),
                                      disabled: false,
                                  },
                                  {
                                      name: t('button.cancel'),
                                      className: 'btn--secondary',
                                      onClick: () => handleCloseModal(),
                                      disabled: false,
                                  },
                              ]
                            : [
                                  {
                                      name: t('button.OK'),
                                      className: 'btn--primary',
                                      onClick: () => handleCloseModal(),
                                      disabled: false,
                                  },
                              ]),
                    ]}
                >
                    <p className="text-center">
                        {selectedRequest.length > 0
                            ? `${selectedRequest.length}件のデータを削除します。本当に削除しますか？`
                            : '削除するデータを選択してください。'}
                    </p>
                </Modal>
            )}
            <Modal
                size="sm"
                type="please_select_checkbox"
                isShow={isInstructionSelect}
                onClose={handleCloseModal}
                isShowIconClose="true"
                title={t('approved_registration_price.continue-registration-prohibited-modal.title')}
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--primary',
                        onClick: () => handleCloseModal(),
                        disabled: false,
                    },
                ]}
            >
                <p className="text-center">{t('approved_registration_price.continue-registration-prohibited-modal.body.text01')}</p>
                <p className="text-center">{t('approved_registration_price.continue-registration-prohibited-modal.body.text02')}</p>
            </Modal>
            <Modal
                size="sm"
                isShow={isShowModalApprove}
                onClose={handleCloseModalApprove}
                isShowIconClose="true"
                title={'選択した商品を継続登録します。'}
                className="registration-edit-modal"
                btnList={[
                    {
                        name: t('approved_registration_price.modal.continue_registration.footer.button.continue'),
                        className: 'btn--primary',
                        onClick: () => handleSubmitModalApprove(),
                        disabled: !selectedSource || !selectedStartDate || !selectedEndDate || !authorizerName,
                    },
                    {
                        name: t('approved_registration_price.modal.continue_registration.footer.button.cancel'),
                        className: 'btn--secondary',
                        onClick: () => handleCloseModalApprove(),
                        disabled: false,
                    },
                ]}
            >
                <p className="text-center">{t('approved_registration_price.modal.continue_registration.body.text_01')}</p>
                <p className="text-center">情報取得元、開始日、終了日、承認者名を入力してください。</p>
                <div className="approval-source">
                    <Choice
                        id="source"
                        column="col-xl-3 col-lg-4 col-md-5"
                        type="radio"
                        data={sources}
                        onChange={(value) => handleChangeState('selectedSource', value[0])}
                        checked={[selectedSource]}
                    />
                </div>
                <div className="approval-date">
                    <ReactCalender
                        value={selectedStartDate}
                        onChange={(value) => handleChangeState('selectedStartDate', value)}
                        classNameInputDateTime="text-center"
                        minDate={minStartDate}
                        maxDate={maxStartDate}
                    />
                    <span className="approval-date__tilde">〜</span>
                    <ReactCalender
                        value={selectedEndDate}
                        onChange={(value) => handleChangeState('selectedEndDate', value)}
                        classNameInputDateTime="text-center"
                        minDate={minEndDate}
                        maxDate={new Date(maxEndDateMinFourteen(selectedStartDate))}
                    />
                </div>
                <div className="approval-name">
                    <Input
                        className="form-control form-control--input"
                        name="authorizerName"
                        type="text"
                        autocomplete="off"
                        maxLength="45"
                        placeholder={t('confirm_registration_price.modal_confirm_deleted_csv.approval_name.label')}
                        value={authorizerName}
                        onChange={(value) => handleChangeState('authorizerName', value)}
                    />
                </div>
            </Modal>
        </>
    );
};

export default ChangeRequestApproved;
